import {
  Button,
  CloseIcon,
  DeleteIcon,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  styled,
  Typography,
  useTheme,
} from 'opensolar-ui'
import React from 'react'
import { StyledDialogTitle, StyledSaveButton } from './components'

interface RemoveItemDialogProps {
  componentTitle: string
  handleClose: () => void
  handleRemoveItem: () => void
}

const StyledDialogContent = styled(DialogTitle)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '40px 24px',
})

const IconContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '12px',
  background: theme.palette.secondary.main,
  borderRadius: 8,
  marginBottom: '16px',
}))

const ContentText = styled('span')(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.neutralGrey[1300],
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '22px',
  marginBottom: '8px',
}))

const ContentSubtext = styled('span')(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.neutralGrey[1000],
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '`8px',
}))

const RemoveItemDialog: React.FC<RemoveItemDialogProps> = ({ componentTitle, handleClose, handleRemoveItem }) => {
  const theme = useTheme()
  return (
    <Dialog open={true} onClose={handleClose}>
      <StyledDialogTitle>
        <Typography textVariant="modalTitle" colorHex={theme.palette.neutralGrey[1300] as `#${string}`}>
          Remove Item
        </Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon color={theme.palette.neutralGrey[800]} size={16} />
        </IconButton>
      </StyledDialogTitle>
      <StyledDialogContent>
        <IconContainer>
          <DeleteIcon color={theme.palette.neutralGrey[900]} width="24" height="24 " />
        </IconContainer>
        <ContentText>Are you sure you want to remove {componentTitle} your Bill of Materials?</ContentText>
        <ContentSubtext>
          This change only affects the Hardware Order and won’t impact your design proposal.
        </ContentSubtext>
      </StyledDialogContent>
      <DialogActions>
        <Button variant="outlined" color="default" onClick={handleClose}>
          <Typography textVariant="body1" colorHex={theme.palette.neutralGrey[1000] as `#${string}`}>
            Cancel
          </Typography>
        </Button>
        <StyledSaveButton variant="contained" onClick={handleRemoveItem}>
          <Typography textVariant="body1" colorHex={theme.palette.neutralGrey[100] as `#${string}`}>
            Remove Item
          </Typography>
        </StyledSaveButton>
      </DialogActions>
    </Dialog>
  )
}

export default RemoveItemDialog
